import { jsx as r } from "react/jsx-runtime";
import { SnowflakeIcon as n, FireIcon as I } from "../Thermometer/styles.js";
import { CheckIcon as e, InfoIcon as O } from "./style.js";
import { Snowflake as i, FireFlameCurved as c, Check as C, CircleInfo as a } from "@pelando/fontawesome/icons";
var f = /* @__PURE__ */ ((o) => (o.WITHOUT_PRICE_HISTORIC = "WITHOUT_PRICE_HISTORIC", o.COLD = "COLD", o.NORMAL = "NORMAL", o.HOT = "HOT", o))(f || {});
const t = (o) => ({
  COLD: /* @__PURE__ */ r(n, { icon: i, "aria-label": "ícone de preço frio" }),
  HOT: /* @__PURE__ */ r(I, { icon: c, "aria-label": "ícone de preço quente" }),
  NORMAL: /* @__PURE__ */ r(e, { icon: C, "aria-label": "ícone de preço normal" }),
  WITHOUT_PRICE_HISTORIC: /* @__PURE__ */ r(O, { icon: a, "aria-label": "ícone de preço sem histórico" })
})[o];
function u({ priceRangeFit: o }) {
  return o ? o <= 25 ? "COLD" : o <= 75 ? "NORMAL" : "HOT" : "WITHOUT_PRICE_HISTORIC";
}
export {
  f as ThermometerPriceState,
  t as getIconByPriceState,
  u as getPriceState
};
